import anime from 'animejs';

const heightFactor = 0.5;

export default class BuScrollAnimation {
    constructor() {
        this.dom = {
            $window: window,
            $outer: document.querySelector('.bu-scroll-outer'),
            $sections: document.querySelectorAll('.bu-section'),
            $urls: document.querySelectorAll('.bu-section-link'),
        };

        if (!this.dom.$outer) {
            return;
        }

        this.animationHeight = (this.dom.$sections.length * this.dom.$sections[0].clientHeight) * heightFactor

        this.tl = anime.timeline({
            autoplay: false,
            update: (anim) => {
                this.setActiveTabBasedOnProgress(anim.progress);
            }
        });

        this.init();
    }

    init() {
        this.getMaxHeight();
        this.animation();
        this.eventScroll();
        this.eventNavigation();

        setTimeout(() => {
            this.setActiveTabBasedOnProgress(this.tl.progress);
        }, 500);
    }

    setActiveTabBasedOnProgress(progress) {
        const count = this.dom.$sections.length;
        const sectionLength = 100 / count;
        const percent = +Math.round(progress);

        for(let i = 0; i<count; i++) {
            const start = i * sectionLength;
            const end = start + sectionLength;

            if (percent >= start && percent <= end) {
                if (!this.dom.$sections[i].classList.contains('bu-section--active')) {
                    [...this.dom.$urls].forEach((item) => item.classList.remove('active-link'));
                    [...this.dom.$sections].forEach((item) => item.classList.remove('bu-section--active'));
                    this.dom.$sections[i].classList.add('bu-section--active');
                    this.dom.$urls[i].classList.add('active-link');
                }
            }
        }
    }

    getMaxHeight() {
        this.dom.$outer.style.height = `${ this.animationHeight }px`;
    }

    animation() {
        [...this.dom.$sections].forEach(($el, index) => {
            const $title = $el.querySelector('.tl__title');
            const $image = $el.querySelector('.tl__image');
            const $list = $el.querySelector('.tl__list');
            const $url = $el.querySelector('.tl__url');


            if (index !== this.dom.$sections.length - 1) {
                this.tl.add({
                    targets: [$title, $image, $list, $url],
                })
            }
        });
    }

    eventNavigation() {
        [...this.dom.$urls].forEach(($el) => {
            const $this = this;
            $el.addEventListener('click', function(e) {
                e.preventDefault();
                const index = Array.from(this.parentNode.children).indexOf(this);
                const distance = $this.dom.$outer.getBoundingClientRect().top + window.scrollY

                const length = $this.animationHeight - window.innerHeight;
                const itemPercent = 100 / $this.dom.$sections.length / 5; // procent dla jednego animowanego elementu. 100 przez liczbe sekcji przez ilosc animacji na sekcje
                let targetPercentageDistance = (index * (itemPercent * 5)) + (itemPercent * 4);

                if (targetPercentageDistance > 90) {
                    targetPercentageDistance = 100;
                }

                anime({
                    targets: [document.documentElement, document.body],
                    scrollTop: distance + (length / 100 * targetPercentageDistance),
                    duration: 0,
                    easing: 'easeInOutQuad'
                })
            });
        });
    }

    eventScroll() {
        this.dom.$window.addEventListener('scroll', () => {
            const rect = this.dom.$outer.getBoundingClientRect();
            const checkTopMargin = rect.top < 0 && (rect.bottom > 0 && rect.bottom <= rect.height);
            const checkBottomMargin = rect.bottom > 0 && (rect.top < 0 && Math.abs(rect.top) <= (rect.height));

            if (!checkTopMargin && !checkBottomMargin) return false;

            const percentage = (Math.abs(rect.y) / (this.dom.$outer.clientHeight - this.dom.$sections[0].clientHeight));

            this.tl.seek(this.tl.duration * percentage);
        });
    }
}



// WEBPACK FOOTER //
// ./sources/js/components/bu-scroll-animation.js